import React from "react";
import Swipe from "react-swipe";

let ImageViewer = React.createClass({
    propTypes: {
        data: React.PropTypes.arrayOf(React.PropTypes.object).isRequired
    },
    getInitialState() {
        return {
            current: 0,
            last: 1,
            carouselIndex: 0
        };
    },
    setCurrent(i) {
        this.setState({
            current: i,
            last: this.state.current
        });
    },
    carouselCallback(i) {
        this.setState({carouselIndex: i});
    },
    render() {
        return (
            <div className={["eo-img-viewer", this.props.className].join(" ")}>
                <div className="eo-img-viewer-images hide-s">
                    {this.props.data.map((img, i) => (
                        <div className={["eo-img-viewer-img-wrap", (this.state.current === i ? "in" : ""), (this.state.last === i ? "in-2" : "")].join(" ")} key={i}>
                            <img className="eo-img-viewer-img eo-img-fluid" src={img.url}/>
                        </div>
                    ))}
                </div>

                <div className="eo-img-viewer-thumbs-wrap hide-s">
                    <ul className="eo-img-viewer-thumbs">
                        {this.props.data.map((slide, i) => (
                            <li key={i} className="eo-img-viewer-thumb-wrap">
                                <div className={["eo-img-viewer-thumb", (this.state.current === i ? "active" : "")].join(" ")} onClick={this.setCurrent.bind(null, i)}>
                                    <img className="eo-img-viewer-thumb-img eo-img-fluid" src={slide.thumbUrl}/>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="eo-img-viewer-mobile">
                    <Swipe slideToIndex={this.state.carouselIndex} className="carousel" callback={this.carouselCallback}>
                        {this.props.data.map((img, i) => (
                            <div key={i} className="eo-img-viewer-img-mobile-wrap">
                                <img className="eo-img-viewer-img eo-img-fluid" src={img.url}/>
                            </div>
                        ))}
                    </Swipe>
                    <div className="carousel-dots">
                        {this.props.data.map((img, i) => <span key={i} onClick={this.carouselCallback.bind(null, i)} className={["carousel-dot", (i === this.state.carouselIndex ? "active" : "")].join(" ")}/>)}
                    </div>
                </div>

            </div>
        );
    }
});

export default ImageViewer;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/technology/components/ImageViewer.js
 **/